
/** 去除收尾空格 */
export const removeLeadingAndTrailingSpaces = (value: string | undefined) => {
    if(value !== undefined) {
        return value.replace(/^\s+|\s+$/g, '');
    } else {
        return value;
    }
};